import { memo as e } from "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { getRepubMetaFromRepub as r, removeRepubPrefix as i } from "@cx-web/utils";
var a = {
	breadcrumbsContainer: "_breadcrumbsContainer_rgs4x_1",
	breadcrumbsWrapper: "_breadcrumbsWrapper_rgs4x_13",
	breadCrumbLi: "_breadCrumbLi_rgs4x_24",
	breadCrumbText: "_breadCrumbText_rgs4x_48",
	breadCrumbLink: "_breadCrumbLink_rgs4x_55",
	breadCrumbLast: "_breadCrumbLast_rgs4x_77",
	breadcrumbsOl: "_breadcrumbsOl_rgs4x_125",
	arrowWrap: "_arrowWrap_rgs4x_143",
	arrow: "_arrow_rgs4x_143"
}, o = ({ dataSchema: e, path: o, repub: s }) => {
	let { repubPath: c } = r(s), l = i(o, s).split("/").filter(Boolean), u = `${c}/`, d = e ?? {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: l.map((e, t) => ({
			"@type": "ListItem",
			item: {
				"@id": `${c}/${l.slice(0, t + 1).join("/")}`,
				"@type": "WebPage",
				name: e.replace(/-/g, " ")
			},
			position: t + 1
		}))
	};
	return /* @__PURE__ */ n("nav", {
		"aria-label": "breadcrumbs",
		className: a.breadcrumbsContainer,
		"data-testid": "breadcrumbs",
		children: [/* @__PURE__ */ t("div", {
			className: a.breadcrumbsWrapper,
			children: /* @__PURE__ */ n("ol", {
				className: a.breadcrumbsOl,
				children: [/* @__PURE__ */ t("li", {
					className: a.breadCrumbLi,
					children: /* @__PURE__ */ t("a", {
						"data-testid": "home-anchor",
						href: u,
						children: /* @__PURE__ */ t("svg", {
							"aria-label": "home",
							"data-testid": "home-image",
							fill: "none",
							height: "14",
							role: "img",
							viewBox: "0 0 16 16",
							width: "14",
							xmlns: "http://www.w3.org/2000/svg",
							children: /* @__PURE__ */ t("path", {
								d: "m15.568 6.96-.001-.002L9.04.432A1.463 1.463 0 0 0 8 0c-.394 0-.764.153-1.042.432L.434 6.955l-.007.006a1.475 1.475 0 0 0 1.026 2.512h.26v4.803c0 .95.773 1.724 1.724 1.724H5.99c.26 0 .47-.21.47-.469v-3.765c0-.434.352-.787.786-.787h1.506c.434 0 .786.353.786.787v3.765c0 .26.21.469.47.469h2.553c.95 0 1.724-.773 1.724-1.724V9.473h.24c.394 0 .764-.153 1.042-.431a1.475 1.475 0 0 0 .001-2.083z",
								fill: "#D6D6D6"
							})
						})
					})
				}), l.map((e, r) => {
					let i = `${c}/${l.slice(0, r + 1).join("/")}`, o = r === l.length - 1, s = e.replace(/-/g, " "), u = /* @__PURE__ */ t("span", {
						className: a.breadCrumbText,
						"data-testid": "breadcrumb-text",
						children: s
					});
					return /* @__PURE__ */ n("li", {
						className: a.breadCrumbLi,
						children: [/* @__PURE__ */ t("span", {
							className: a.arrowWrap,
							children: /* @__PURE__ */ t("svg", {
								"aria-label": "arrow",
								className: a.arrow,
								"data-testid": "arrow-image",
								fill: "none",
								height: "14",
								role: "img",
								viewBox: "0 0 9 16",
								width: "8",
								xmlns: "http://www.w3.org/2000/svg",
								children: /* @__PURE__ */ t("path", {
									d: "M8 2 2 8l6 6",
									stroke: "#fff",
									strokeWidth: "2.304"
								})
							})
						}), o ? /* @__PURE__ */ t("span", {
							className: a.breadCrumbLast,
							children: u
						}) : /* @__PURE__ */ t("a", {
							className: a.breadCrumbLink,
							"data-testid": "breadcrumb-link",
							href: i,
							title: s,
							children: u
						})]
					}, i);
				})]
			})
		}), /* @__PURE__ */ t("script", {
			dangerouslySetInnerHTML: { __html: JSON.stringify(d) },
			type: "application/ld+json"
		})]
	});
}, s = e(o);
//#endregion
export { o as Breadcrumbs, s as default };
